import config from "@/config"
import http from "@/utils/request"
import tool from "@/utils/tool"
const userInfo = tool.data.get("USER_INFO")
let storeId = ""
if (userInfo) {
  storeId = userInfo["storeIds"][0]
}

export default {
  manage: {
    url: `${config.API_URL}/businessCalendar/manage`,
    name: "营业日历管理",
    /** 常规营业规则 */
    regular: {
      url: `${config.API_URL}/businessCalendar/manage/regular`,
      name: "常规营业规则",
      get: async function (params) {
        return await http.get(`${this.url}/list`, params) // 获取常规规则列表
      },
      create: async function (params) {
        return await http.post(`${this.url}/create`, params) // 创建常规规则
      },
      detail: async function (params) {
        return await http.post(`${this.url}/detail`, params) // 获取常规规则详情
      },
      update: async function (params) {
        return await http.post(`${this.url}/update`, params) // 更新常规规则
      },
      delete: async function (params) {
        return await http.post(`${this.url}/delete`, params) // 删除常规规则
      }
    },
    /** 特殊日期覆盖 */
    special: {
      url: `${config.API_URL}/businessCalendar/manage/special`,
      name: "特殊日期",
      get: async function (params) {
        return await http.get(`${this.url}/list`, params) // 获取特殊日期列表
      },
      create: async function (params) {
        return await http.post(`${this.url}/create`, params) // 创建特殊日期
      },
      detail: async function (params) {
        return await http.post(`${this.url}/detail`, params) // 获取特殊日期详情
      },
      update: async function (params) {
        return await http.post(`${this.url}/update`, params) // 更新特殊日期
      },
      delete: async function (params) {
        return await http.post(`${this.url}/delete`, params) // 删除特殊日期
      }
    },
    /** 库存日历 */
    inventory: {
      url: `${config.API_URL}/businessCalendar/manage/inventory`,
      name: "库存日历",
      get: async function (params) {
        return await http.get(`${this.url}/list`, params) // 获取库存日历列表
      },
      create: async function (params) {
        return await http.post(`${this.url}/create`, params) // 创建库存日历
      },
      detail: async function (params) {
        return await http.post(`${this.url}/detail`, params) // 获取库存日历详情
      },
      update: async function (params) {
        return await http.post(`${this.url}/update`, params) // 更新库存日历
      },
      delete: async function (params) {
        return await http.post(`${this.url}/delete`, params) // 删除库存日历
      },
      deduct: async function (params) {
        return await http.post(`${this.url}/deduct`, params) // 扣减库存（乐观锁）
      }
    },
    /** 营业状态查询 */
    query: {
      url: `${config.API_URL}/businessCalendar/manage/query`,
      name: "营业状态查询",
      queryDay: async function (params) {
        return await http.post(`${this.url}/day`, params) // 查询某天营业状态
      },
      queryRange: async function (params) {
        return await http.post(`${this.url}/range`, params) // 查询日期范围营业状态
      }
    }
  },
  /** ─── 店家端 ─── */
  owner: {
    url: `${config.API_URL}/businessCalendar/owner`,
    name: "营业日历管理",
    /** 常规营业规则 */
    regular: {
      url: `${config.API_URL}/businessCalendar/owner/regular`,
      name: "常规营业规则",
      get: async function (params) {
        return await http.get(`${this.url}/list`, { ...params, storeId }) //  获取我的常规规则列表
      },
      create: async function (params) {
        return await http.post(`${this.url}/create`, { ...params, storeId }) // 创建我的常规规则
      },
      detail: async function (params) {
        return await http.post(`${this.url}/detail`, params) // 获取我的常规规则详情
      },
      update: async function (params) {
        return await http.post(`${this.url}/update`, { ...params, storeId }) // 更新我的常规规则
      },
      setStoreBusinessStatus: async function (params) {
        return await http.post(`${this.url}/setStoreBusinessStatus`, { ...params, storeId }) // 设置店铺营业状态
      },
      delete: async function (params) {
        return await http.post(`${this.url}/delete`, params) // 删除我的常规规则
      }
    },
    /** 特殊日期覆盖 */
    special: {
      url: `${config.API_URL}/businessCalendar/owner/special`,
      name: "特殊日期",
      get: async function (params) {
        return await http.get(`${this.url}/list`, params) // 获取我的特殊日期列表
      },
      getMonthData: async function (params) {
        return await http.get(`${this.url}/list/date`, params) // 获取我的特殊日期列表
      },
      create: async function (params) {
        return await http.post(`${this.url}/create`, params) // 创建我的特殊日期
      },
      detail: async function (params) {
        return await http.post(`${this.url}/detail`, params) // 获取我的特殊日期详情
      },
      update: async function (params) {
        return await http.post(`${this.url}/update`, params) // 更新我的特殊日期
      },
      delete: async function (params) {
        return await http.post(`${this.url}/delete`, params) // 删除我的特殊日期
      }
    },
    /** 库存日历 */
    inventory: {
      url: `${config.API_URL}/businessCalendar/owner/inventory`,
      name: "库存日历",
      get: async function (params) {
        return await http.get(`${this.url}/list`, { ...params, storeId: tool.data.get("USER_INFO")["storeIds"][0] }) // 获取我的库存日历列表
      },
      create: async function (params) {
        return await http.post(`${this.url}/create`, { ...params, storeId: tool.data.get("USER_INFO")["storeIds"][0] }) // 获取我的库存日历列表
      },
      update: async function (params) {
        return await http.post(`${this.url}/update`, { ...params, storeId: tool.data.get("USER_INFO")["storeIds"][0] }) // 获取我的库存日历列表
      },
      detail: async function (params) {
        return await http.post(`${this.url}/detail`, params) // 获取我的库存日历详情
      },

      delete: async function (params) {
        return await http.post(`${this.url}/delete`, params) // 删除我的库存日历
      },
      deduct: async function (params) {
        return await http.post(`${this.url}/deduct`, params) // 扣减库存（乐观锁）
      }
    },
    /** 营业状态查询 */
    query: {
      url: `${config.API_URL}/businessCalendar/owner/query`,
      name: "营业状态查询",
      queryDay: async function (params) {
        return await http.post(`${this.url}/day`, params) // 查询某天营业状态
      },
      queryRange: async function (params) {
        return await http.post(`${this.url}/range`, params) // 查询日期范围营业状态
      }
    }
  }
}
